export const DataBindingSources = {
    Filer: [
        {
            value: 'Filer.CpfId',
            description: 'CpfId'
        },
        {
            value: 'Filer.AccountType',
            description: 'AccountType'
        },
        {
            value: 'Filer.FullName',
            description: 'FullName'
        },
        {
            value: 'Filer.FullNameReverse',
            description: 'FullNameReverse'
        },
        {
            value: 'Filer.CommitteeName',
            description: 'CommitteeName'
        },
        {
            value: 'Filer.AuditorId',
            description: 'AuditorId'
        },
        {
            value: 'Filer.AuditorEmailAddress',
            description: 'AuditorEmailAddress'
        },
        {
            value: 'Filer.LabelName',
            description: 'LabelName'
        },
        {
            value: 'Filer.CandidateEmailAddress',
            description: 'CandidateEmailAddress'
        },
        {
            value: 'Filer.TreasurerEmailAddress',
            description: 'TreasurerEmailAddress'
        },
        {
            value: 'Filer.ChairmanEmailAddress',
            description: 'ChairmanEmailAddress'
        },
        {
            value: 'Filer.OrgDate',
            description: 'OrgDate'
        },
        {
            value: 'Filer.OfficeSoughtDescription',
            description: 'OfficeSoughtDescription'
        },
        {
            value: 'Filer.PartyAffiliation',
            description: 'PartyAffiliation'
        }

    ],
    Item: [
        {
            value: 'Item.Date',
            description: 'Date'
        },
        {
            value: 'Item.Amount',
            description: 'Amount'
        },
        {
            value: 'Item.Name',
            description: 'Name'
        },
        {
            value: 'Item.First Name',
            description: 'First Name'
        },
        {
            value: 'Item.Street Address',
            description: 'Street Address'
        },
        {
            value: 'Item.City',
            description: 'City'
        },
        {
            value: 'Item.State',
            description: 'State'
        },
        {
            value: 'Item.ZipCode',
            description: 'ZipCode'
        },
        {
            value: 'Item.Purpose',
            description: 'Purpose'
        },
        {
            value: 'Item.Clarified Purpose',
            description: 'Clarified Purpose'
        },
        {
            value: 'Item.RelatedCpfId',
            description: 'RelatedCpfId'
        },
        {
            value: 'Item.FullName',
            description: 'FullName'
        },
        {
            value: 'Item.FullNameReverse',
            description: 'FullNameReverse'
        },
        {
            value: 'Item.CityStateZipCode',
            description: 'CityStateZipCode'
        },
        {
            value: 'Item.Occupation',
            description: 'Occupation'
        },
        {
            value: 'Item.Employer',
            description: 'Employer'
        },
        {
            value: 'Item.Vendor',
            description: 'Vendor'
        },
        {
            value: 'Item.Clarified Vendor',
            description: 'Clarified Vendor'
        },
        {
            value: 'Item.AuditorNote',
            description: 'AuditorNote'
        },
    ],
    Report: [
        {
            value: 'Report.ReportId',
            description: 'ReportId'
        },
        {
            value: 'Report.ReportTypeId',
            description: 'ReportTypeId'
        },
        {
            value: 'Report.ReportTypeDescription',
            description: 'ReportTypeDescription'
        },
        {
            value: 'Report.CpfId',
            description: 'CpfId'
        },
        {
            value: 'Report.CommitteeName',
            description: 'CommitteeName'
        },
        {
            value: 'Report.ReportYear',
            description: 'ReportYear'
        },
        {
            value: 'Report.StartDate',
            description: 'StartDate'
        },
        {
            value: 'Report.EndDate',
            description: 'EndDate'
        },
        {
            value: 'Report.StartBalance',
            description: 'StartBalance'
        },
        {
            value: 'Report.ReceiptTotal',
            description: 'ReceiptTotal'
        },
        {
            value: 'Report.ExpenditureTotal',
            description: 'ExpenditureTotal'
        },
        {
            value: 'Report.EndBalance',
            description: 'EndBalance'
        },
        {
            value: 'Report.InkindTotal',
            description: 'InkindTotal'
        },
        {
            value: 'Report.LiabilityTotal',
            description: 'LiabilityTotal'
        },

    ],
    Letter: [
        {
            value: 'Letter.LetterTemplateCode',
            description: 'LetterTemplateCode'
        },
        {
            value: 'Letter.Date',
            description: 'Date'
        },
        {
            value: 'Letter.MediumDate',
            description: 'MediumDate'
        },
        {
            value: 'Letter.DueDate',
            description: 'DueDate'
        },
        {
            value: 'Letter.Subject',
            description: 'Subject'
        },
        {
            value: 'Letter.FilerAccountTypeCode',
            description: 'FilerAccountTypeCode'
        }
    ],
    Issue: [
        {
            value: 'Issue.AuditReportingPeriod',
            description: 'AuditReportingPeriod'
        },
        {
            value: 'Issue.AuditPeriodStartDate',
            description: 'AuditPeriodStartDate'
        },
        {
            value: 'Issue.AuditPeriodEndDate',
            description: 'AuditPeriodEndDate'
        },
        {
            value: 'Issue.CreditTotal',
            description: 'CreditTotal'
        },
        {
            value: 'Issue.DepositTotal',
            description: 'DepositTotal'
        },
        {
            value: 'Issue.ReceiptDiscrepancy',
            description: 'ReceiptDiscrepancy'
        },
    ]
}


export default DataBindingSources